<template>
  <div class="loop">
    <div v-if="!start" class="start-screen">
      <button @click="startLoop" class="start-button">
        START
        <i class="play-icon material-icons-round">play_arrow</i>
      </button>
    </div>
    <div v-if="start" class="content">
      <Post
        v-if="selectedPost"
        :key="selectedPost.id"
        :post="selectedPost"
        :view="'screen'"
        :mode="'screen'"
        @ended="next"
      />
      <audio v-if="post" id="player" :ref="'audio'" autoplay>
        <source :src="post.audio.source" />
      </audio>
      <button
        :style="post ? 'right: 65px' : 'right: 10px'"
        class="pause-button"
        @click="pauseLoop"
      >
        <i class="material-icons-round">{{ pause ? "play_arrow" : "pause" }}</i>
      </button>
      <button v-if="post" class="mute-button" @click="muteAudio">
        <i class="material-icons-round">{{
          mute ? "volume_up" : "volume_off"
        }}</i>
      </button>
    </div>
  </div>
</template>

<script>
import Post from "../pinwall/Post";

export default {
  components: {
    Post
  },
  name: "loop",
  data: () => {
    return {
      start: false,
      selectedPost: null,
      index: 0,
      post: null,
      mute: false,
      pause: false
    };
  },
  watch: {
    posts: "init"
  },
  props: {
    posts: {
      type: Array,
      default: null
    },
    interval: {
      type: Number,
      default: 4000
    }
  },
  methods: {
    startLoop() {
      this.start = !this.start;
      this.next();
    },
    pauseLoop() {
      this.pause = !this.pause;

      if (!this.mute) {
        this.muteAudio();
      }

      if (!this.pause) {
        if (this.mute) {
          this.muteAudio();
        }
        this.next();
      }
    },
    muteAudio() {
      this.mute = !this.mute;
      var player = this.$refs["audio"];
      if (player) {
        player.muted = this.mute;
      }
    },
    next() {
      if (this.pause) {
        return;
      }
      this.index = this.index > this.posts.length - 1 ? 0 : this.index;
      for (this.index; this.index < this.posts.length; this.index++) {
        const newPost = this.posts[this.index];
        if (newPost.video || newPost.image) {
          this.selectedPost = this.posts[this.index];
          this.selectedPost.playMedia = true;
          this.index += 1;

          if (!newPost.video) {
            setTimeout(() => {
              this.next();
            }, this.interval);
          }
          return;
        }
      }
    },
    init() {
      this.post = this.posts.find(post => post.audio !== null);
    }
  }
};
</script>
